import * as z from "zod";
import { zRequiredString } from "./schemaUtils";

export const schemaFormEventValidate = z.object({
  validateOrRefuse: z.enum(["validate", "refused"]),
  comment: zRequiredString("Veuillez saisir un commentaire"),
});
